import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  heatmap_pitch: require("../../../assets/wc/images/pitch_heatmap_transparent_fcb.png"),
  right_arrow: require("../../../assets/svg/arrow-right.svg"),
  background_1920: require("../../../assets/of/videos/background_1920x1080_v2.webm"),
};

export default assets;
